const filmes = [
    {
        "id": 4,
        "nome": "Manhã de Domingo",
        "nome_en": "Sunday Morning",
        "uri": "manha-de-domingo",
        "imagem_capa":"/filmes/domingo/capa.png",
        "video_capa": "/filmes/domingo/domingo.mp4",
        "ano": 2022,
        "duração": 25,
        "estado": "RJ",
        "sinopse": "Gabriela é uma jovem pianista que irá se apresentar em seu primeiro grande recital. No entanto, um sonho com sua falecida mãe desestabiliza a mente e o coração de Gabriela, colocando em risco a sua apresentação. A partir de uma série de encontros ao longo de um dia, Gabriela irá se jogar em uma jornada de reconciliação com suas memórias e sua mãe.",
        "trailer": "658351026",
        "ficha_técnica": {
            "Elenco": "Raquel Paixão, Leonardo Castro, Silvana Stein, André Pacheco, Indira Nascimento, Valéria Lima, Ítalo Pereira e Layza Griot",
            "Direção": "Bruno Ribeiro",
            "Roteiro": "Bruno Ribeiro e Tuanny Medeiros",
            "Produção Executiva": "Laís Diel",
            "Assistente de direção": "Carla Villa-Lobos",
            "Direção de produção":"Laís Diel e Julia Monnerat",
            "Assistentes de produção": "Erivan Dantas e Victoria Zanardi",
            "Direção de Fotografia": "Wilssa Esser",
            "Assistentes de fotografia": "Érica Rocha e Thaís Grechi",
            "Direção de Arte":"Diogo Hayashi",
            "Assistentes de arte": "Daniel Santiso, Maria Leite e Mariana Cypriano",
            "Som": "Gustavo Andrade",
            "Microfonista": "Mariana Graciotti",
            "Elétrica e maquinária": "Bernard Machado",
            "Assistente de elétrica e maquinaria": "Marina Gurgel",
            "Figurino": "Mayra Barroso",
            "Assistente de figurino": "De Beija",
            "Maquiagem e cabelo": "Ingrid Louise",
            "Still": "Vitor Moniz",
            "Montagem": "Vinícius Silva",
            "Edição de som e mixagem": "Bernardo Uzeda"
        },
        "ficha_técnica_en": {
            "Cast": "Raquel Paixão, Leonardo Castro, Silvana Stein, André Pacheco, Indira Nascimento, Valéria Lima, Ítalo Pereira, and Layza Griot",
            "Directed by": "Bruno Ribeiro",
            "Written by": "Bruno Ribeiro and Tuanny Medeiros",
            "Executive Production": "Laís Diel",
            "Assistant Director": "Carla Villa-Lobos",
            "Production Direction": "Laís Diel and Julia Monnerat",
            "Production Assistants": "Erivan Dantas and Victoria Zanardi",
            "Director of Photography": "Wilssa Esser",
            "Photography Assistants": "Érica Rocha and Thaís Grechi",
            "Art Direction": "Diogo Hayashi",
            "Art Assistants": "Daniel Santiso, Maria Leite, and Mariana Cypriano",
            "Sound": "Gustavo Andrade",
            "Boom Operator": "Mariana Graciotti",
            "Electricity and Machinery": "Bernard Machado",
            "Assistant Electrician and Machinist": "Marina Gurgel",
            "Costume Design": "Mayra Barroso",
            "Assistant Costume Designer": "De Beija",
            "Makeup and Hair": "Ingrid Louise",
            "Still Photography": "Vitor Moniz",
            "Editing": "Vinícius Silva",
            "Sound Editing and Mixing": "Bernardo Uzeda"
        },
        "festivais": ["Urso de Prata - Festival de Berlim","Best Short Narrative - BlackStar Film Festival (Best Short Narrative)","Festival Internacional de Curtas-metragens de São Paulo – Kinoforum (Prêmio Porta Curtas)","Doclisboa","Festival de Huelva","Festival Internacional del Nuevo Cine Latinoamericano de La Habana","FESPACO","Mostra de Cinema de Tiradentes ","Olhar de Cinema","Goiânia Mostra Curtas","Mostra de Cinema de Vitória","Festival Curta Cinema","FestCurtas BH"],
        "galeria": ["/filmes/domingo/galeria/1.jpg", "/filmes/domingo/galeria/2.jpg", "/filmes/domingo/galeria/3.jpg"]

    },
    {
        "id": 3,
        "nome": "Gargaú",
        "nome_en": "Gargaú",
        "uri": "gargau",
        "imagem_capa":"/filmes/gargau/capa.png",
        "video_capa": "/filmes/gargau/gargau.mp4",
        "ano": 2021,
        "duração": 19,
        "estado": "RJ",
        "sinopse": "Bruno entra em um carro com desconhecidos.",
        "trailer": "569532079",
        "ficha_técnica": {
            "Elenco": "Bruno Ribeiro, Dona Graça, Gabriela Montoni, Gustavo Andrade, Lucas Fratini e Tuanny Medeiros",
            "Direção e roteiro": "Bruno Ribeiro",
            "Produção executiva": "Laís Diel",
            "Assistentes de direção": "Lucas Fratini e Tuanny Medeiros",
            "Direção de produção": "Adler Costa, Bruno Ribeiro e Laís Diel",
            "Direção de arte e Figurino": "Adler Costa, Bruno Ribeiro, Dona Graça, Gabriela Montoni, Gustavo Andrade, Lucas Fratini e Tuanny Medeiros",
            "Direção de fotografia": "Bruno Ribeiro, Lucas Fratini e Tuanny Medeiros",
            "Som": "Gustavo Andrade",
            "Montagem": "Bruno Ribeiro",
            "Correção de cor": "Vitor Novaes",
            "Edição de som e mixagem": "Bernardo Uzeda"
        },
        "ficha_técnica_en": {
            "Cast": "Bruno Ribeiro, Dona Graça, Gabriela Montoni, Gustavo Andrade, Lucas Fratini, and Tuanny Medeiros",
            "Directed and written by": "Bruno Ribeiro",
            "Executive Production": "Laís Diel",
            "Assistant Directors": "Lucas Fratini and Tuanny Medeiros",
            "Production Direction": "Adler Costa, Bruno Ribeiro, and Laís Diel",
            "Art Direction and Costume Design": "Adler Costa, Bruno Ribeiro, Dona Graça, Gabriela Montoni, Gustavo Andrade, Lucas Fratini, and Tuanny Medeiros",
            "Cinematography Direction": "Bruno Ribeiro, Lucas Fratini, and Tuanny Medeiros",
            "Sound": "Gustavo Andrade",
            "Editing": "Bruno Ribeiro",
            "Color Correction": "Vitor Novaes",
            "Sound Editing and Mixing": "Bernardo Uzeda"
        },
        "festivais": ["DocLisboa","XIII Janela Internacional de Recife (Prêmio Volvo)","Lâmina - Mostra Audiovisual Preta","Encontro de Cinema Negro Zózimo Bulbul","FestCurtasBH","Curta Cinema","Festival de Cinema de Vitória","Festival Internacional do Audiovisual Negro do Brasil – FIANb"],
        "galeria": ["/filmes/gargau/galeria/1.png", "/filmes/gargau/galeria/2.png"]

    },
    {
        "id": 2,
        "nome": "BR3",
        "nome_en": "BR3",
        "uri": "br3",
        "imagem_capa":"/filmes/br3/capa.png",
        "video_capa": "/filmes/br3/br3.mp4",
        "ano": 2018,
        "duração": 23,
        "estado": "RJ",
        "sinopse": "Kastelany chega na casa de Luciana. Mia se prepara para sair à noite com suas amigas. Dandara transa com Johi pela primeira vez.",
        "trailer": "273545505",
        "ficha_técnica": {
            "Elenco": "Dandara Vital, Johi Farias, Kamyla Galdeano, Kastelany Silva, Leona Kalí, Luciana Vasconcellos e Mia",
            "Direção e roteiro": "Bruno Ribeiro",
            "Produção executiva": "Laís Diel",
            "Assistente de direção": "Victor Rodrigues",
            "Continuísta": "Mariana Moron",
            "Direção de produção": "Laís Diel e Mariana Melo",
            "Assistente de produção": "Amina Sophia",
            "Produção local": "Geo Abreu",
            "Direção de Fotografia": "Thais Faria",
            "Operador de Steadicam": "Tomás Camargo",
            "Assistentes de câmera": "Nelson Teodoro e Lívia Lacorte",
            "Direção de Arte": "Letícia La Rocca",
            "Consultor de Arte": "Hyan Victor",
            "Produção de Arte": "Carlos Marra",
            "Assistentes de Arte": "Bianca Mansur e Lucas Octaviano",
            "Som": "Felipe Carneiro",
            "Microfonista": "Gustavo Silveira",
            "Figurinista": "Lua Guerreiro",
            "Montagem": "Bruno Ribeiro",
            "Correção de cor": "Link Digital ",
            "Edição de som e mixagem": "Bernardo Uzeda",
            "Equipe Maré Sobre Saltos": "Carlos Marra, Gabriel Félix, Karina Marinho e Marcos Aprigio"
        },
        "ficha_técnica_en": {
            "Cast": "Dandara Vital, Johi Farias, Kamyla Galdeano, Kastelany Silva, Leona Kalí, Luciana Vasconcellos, and Mia",
            "Directed and written by": "Bruno Ribeiro",
            "Executive Production": "Laís Diel",
            "Assistant Director": "Victor Rodrigues",
            "Continuity": "Mariana Moron",
            "Production Direction": "Laís Diel and Mariana Melo",
            "Production Assistant": "Amina Sophia",
            "Local Production": "Geo Abreu",
            "Cinematography Direction": "Thais Faria",
            "Steadicam Operator": "Tomás Camargo",
            "Camera Assistants": "Nelson Teodoro and Lívia Lacorte",
            "Art Direction": "Letícia La Rocca",
            "Art Consultant": "Hyan Victor",
            "Art Production": "Carlos Marra",
            "Art Assistants": "Bianca Mansur and Lucas Octaviano",
            "Sound": "Felipe Carneiro",
            "Boom operator": "Gustavo Silveira",
            "Costume Designer": "Lua Guerreiro",
            "Editing": "Bruno Ribeiro",
            "Color Correction": "Link Digital",
            "Sound Editing and Mixing": "Bernardo Uzeda",
            "Maré Sobre Saltos Team": "Carlos Marra, Gabriel Félix, Karina Marinho, and Marcos Aprigio"            
        },
        "festivais": ["Festival de Cinema de Vitória (Prêmio Especial do Júri)","Goiânia Mostra Curtas (Melhor Direção)","XI Janela Internacional de Recife (Menção Honrosa do Júri)","Festival de Cinema Luso-Brasileiro de Santa Maria da Feira (Prêmio Revelação)","IFFR - International Film Festival Rotterdam - Programa Soul in Eye","Festival de Brasília do Cinema Brasileiro","Encontro de Cinema Negro Brasil, África e Caribe Zózimo Bulbul ","FestCurtas BH","Curta Cinema","Recifest","Panorama Internacional Coisa de Cinema ","Semana de Cinema - Circuito Sesc","Festival Mix Brasil de Cultura da Diversidade","Festival Mimoso de Cinema","OutFestPerú","Mostra Pajeú de Cinema","Contrast Film Festival"," Mostra Itinerante de Cinemas Negros Mahomed Bamba","Tamoio","FBCU - Festival Brasileiro de Cinema Universitário","Sertão e Diversidade - Festival Internacional de Curtas","3 Margens: Festival Latino-Americano de Cinema","Curta O Gênero ","Cinecipó - Festival do Filme Insurgente "],
        "galeria": ["/filmes/br3/galeria/1.png", "/filmes/br3/galeria/2.png", "/filmes/br3/galeria/3.png", "/filmes/br3/galeria/4.png"]
    },
    {
        "id": 1,
        "nome": "Pele suja minha carne",
        "nome_en": "Dirty Skin",
        "uri": "pele-suja-minha-carne",
        "imagem_capa":"/filmes/pele/capa.png",
        "video_capa": "/filmes/pele/pele.mp4",
        "ano": 2016,
        "duração": 14,
        "estado": "RJ",
        "sinopse": "João toma banho após mais uma pelada com seus amigos brancos.",
        "trailer": "227066641",
        "ficha_técnica": {
            "Elenco": "André Muniz, Diego Francisco e Fernanda Dias",
            "Direção e roteiro": "Bruno Ribeiro",
            "Produção Executiva": "Laís Diel",
            "Assistente de direção": "Mariana de Melo",
            "Continuidade": "Gabriela Coelho",
            "Preparador de elenco": "Lucas Maia",
            "Direção de produção": "Laís Diel e Julia Monnerat",
            "Assistentes de produção": "Erivan Dantas, Karen Suzane e Thays Pantuza",
            "Direção de Fotografia": "Vitor Novaes e Lucas Vinzon",
            "Assistentes de fotografia": "Juliana Di Lello, Isadora Relvas e Tassiana Catein",
            "Direção de Arte": "Paula Mermelstein",
            "Som": "Miguel Mermelstein e Gustavo Silveira",
            "Montagem": "Bruno Ribeiro e Gabriela Coelho",
            "Correção de cor": "Vitor Novaes",
            "Edição de som e mixagem": "Miguel Mermelstein e Pedro Drummond",
            "Música original": "Miguel Mermelstein",
            "Produtora associada": "Caraduá Produções"
        },
        "ficha_técnica_en": {
            "Cast": "André Muniz, Diego Francisco, and Fernanda Dias",
            "Directed and written by": "Bruno Ribeiro",
            "Executive Production": "Laís Diel",
            "Assistant Director": "Mariana de Melo",
            "Continuity": "Gabriela Coelho",
            "Casting Director": "Lucas Maia",
            "Production Direction": "Laís Diel and Julia Monnerat",
            "Production Assistants": "Erivan Dantas, Karen Suzane, and Thays Pantuza",
            "Cinematography Direction": "Vitor Novaes and Lucas Vinzon",
            "Photography Assistants": "Juliana Di Lello, Isadora Relvas, and Tassiana Catein",
            "Art Direction": "Paula Mermelstein",
            "Sound": "Miguel Mermelstein and Gustavo Silveira",
            "Editing": "Bruno Ribeiro and Gabriela Coelho",
            "Color Correction": "Vitor Novaes",
            "Sound Editing and Mixing": "Miguel Mermelstein and Pedro Drummond",
            "Original Music": "Miguel Mermelstein",
            "Associate Producer": "Caraduá Produções"            
        },
        "festivais": ["Prêmio Elipse 2016","2º Toró Festival Audiovisual Universitário de Belém (Melhor Filme)","1º CORTE Festival (Melhor Montagem)","20º Curta Taquary (Melhor Montagem e Melhor Direção de Arte)"," 28º Festival Internacional de Curtas-Metragens de São Paulo (10 Melhores - Voto Popular)","16ª Mostra de Audiovisual Universitário América Latina UFMT (16MAUAL) (Prêmio Especial do Júri)","Melhor Montagem na Competitiva Nacional e Menção Honrosa pelo Júri do Janela Crítica - X Janela Internacional de Cinema do Recife","X Janela Internacional de Cinema do Recife (Melhor Montagem na Competitiva Nacional e Menção Honrosa pelo Júri do Janela Crítica)","V Recifest: Festival de Cinema da Diversidade Sexual e de Gênero  (Melhor curta nacional pelo Júri Popular e Melhor curta dirigido por homem pelo Júri ABD-PE/APECI)"," Mostra Fronteiras Imaginárias do Festival Visões Periféricas (Menção Honrosa)", "16ª Goiânia Mostra Curtas","Cine Tamoio","FLõ - Festival do Livre Olhar ","Mostra do Filme Livre ","Mostra Outros Cinemas","2º Cinemão / Mostra dxs Bi, das Gay, dxs Trans e das Sapatão","Mostra de Curtas de Ficção da Semana de Imagem e Som 2017 ","Concordia Film Festival ","14ª MIFEC - Mostra Internacional de Filmes de Escolas de Cinema","Encontro de Cinema Negro Zózimo Bulbul - Brasil, África e Caribe ","Korea Queer Film Festival (KQFF)","2ª Mostra Pequi de Audiovisual ","11ª Mostra Audiovisual de Cambuquira ","28º Festival Internacional de Curtas Metragens de São Paulo - Mostra Brasil ","7º Cinecipó – Festival Internacional do Filme Insurgente","19º Festival Internacional de Curtas de Belo Horizonte - Fest Curtas - Mostra Juventudes ","1º FestUniBrasilia - 50º Festival de Brasília do Cinema Brasileiro ","Film Africa 2017 ","11ª Mostra Curta Audiovisual","16ª Mostra de Audiovisual Universitário América Latina UFMT ","Mostra Cine Diversidade - gênero e sexualidade no cinema","Festival Deu Na Telha","CUMEmostra ","Festival Primeiro Plano - Mostra Competitiva Mercocidades ","Lumiar 4º Festival Interamericano de Cinema Universitário","X Janela Internacional de Cinema do Recife","20º FanCineGay - Festival Internacional de Cine LGBT de Extremadura ","XIII Panorama Internacional Coisa de Cinema","24º Festival Mix Brasil ", "IV Festissauro - Festival de Cinema de Sousa ","XII Cinefest Gato Preto - Mostra Protagonistas Negros ",
        "MIRA IV - Festival de Cine Latinoamericano Independiente","III Egbé - Mostra de Cinema Negro","4ª Mostra Curtas Premiados ","I Mostra Itinerante de Cinema Negro Mahomed Bamba (MIMB)","Traços - Arte, Cultura e Negritudes - Escola SESC",
        "6ª Mostra de Curtas Araçá ","Afro-Latino Fest of New York","Festival Sai da Rede 2018","Corpos Dissidentes - Mostra de Cinema Queer de Curitiba","Festival de Cinema de Três Passos"],
        "galeria": ["/filmes/pele/galeria/1.jpg", "/filmes/pele/galeria/2.jpg", "/filmes/pele/galeria/3.jpg", "/filmes/pele/galeria/4.jpg", "/filmes/pele/galeria/5.jpg"]

    },


]

export default filmes